import Swal from "sweetalert2";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";
import { t } from "i18next";
import { debugErrorActions, debugLogActions } from "../helpers/debugHelper";

export const startLoadingCountrys = () => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_COUNTRY}`, "get");
    const body = await resp.json();

     debugLogActions(':: countryActions, startLoadingCountrys', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCountrys(body.countrys));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCountrys = (countrys) => ({
  type: types.COUNTRY_START_LOADING,
  payload: countrys,
});

export const startLoadingCountrysPaginated = (page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_COUNTRY}`, `get/${page}/${size}`);
    const body = await resp.json();

     debugLogActions(':: countryActions, startLoadingCountrysPaginated', { 'body': body });

    if (body.ok) {
      
      dispatch(loadingCountrysPaginated(body.countryPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const loadingCountrysPaginated = (countryPaginated) => ({
  type: types.COUNTRY_START_LOADING_PAGINATED,
  payload: countryPaginated,
});

export const selectCountrys = (country) => ({
  type: types.COUNTRY_SELECT,
  payload: country,
});

export const countryClean = () => ({
  type: types.COUNTRY_CLEAN,
});

export const countryStartDelete = (id) => {
  return async (dispatch) => {
    try {
      await Swal.fire({
        title: t("record_delete.title"),
        text: t("record_delete.text"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("titles.delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          fetchToken(
            `${const_routes.SCHEMA}`,
            `${const_routes.VERSIONV1}`,
            `${const_routes.ROUTE_COUNTRY}`,
            `delete/${id}`,
            { deleted: false },
            "DELETE"
          )
            .then((resp) => resp.json())
            .then((body) => {

               debugLogActions(':: countryActions, countryStartDelete', { 'body': body });

              if (body.ok) {
                dispatch(countryDeleted(id));
              } else {
                if (body.code === "bak-error-001") {
                   Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
                  
                }
                if (body.code === "bak-aut-tok-inv-001") {
                  Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
                  dispatch(startLogout());
                }
                if (body.code === "bak-aut-tok-inv-002") {
                  Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
                  dispatch(startLogout());
                }
              }
            });
          Swal.fire(t("titles.success"), t("record.delete"), "success");
        }
      });
    } catch (error) {
      debugErrorActions(':: catalogCountryActions, countryStartDelete', { 'error': error });
    }
  };
};

const countryDeleted = (id) => {
  return {
    type: types.COUNTRY_DELETE,
    payload: id,
  };
};

export const startSearchingCountrysPaginated = (textSearch, page, size) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_COUNTRY}`,
      `search/${textSearch}/${page}/${size}`
    );
    const body = await resp.json();

     debugLogActions(':: countryActions, startSearchingCountryPaginated', { 'body': body });

    if (body.ok) {
      dispatch(searchingCountrysPaginated(body.countrysPaginated));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const searchingCountrysPaginated = (countrysPaginated) => ({
  type: types.COUNTRY_START_SEARCH_PAGINATED,
  payload: countrysPaginated,
});

export const cleanSearchingCountrysPaginated = () => ({
  type: types.COUNTRY_CLEAN_SEARCH_PAGINATED,
});

export const countryStartUpdate = (country, navigate) => {
  return async (dispatch) => {
    try {
      const resp = await fetchToken(
        `${const_routes.SCHEMA}`,
        `${const_routes.VERSIONV1}`,
        `${const_routes.ROUTE_COUNTRY}`,
        `update/${country.id}`,
        country,
        "PUT"
      );
      const body = await resp.json();

       debugLogActions(':: countryActions, countryStartUpdate', { 'body': body });

      if (body.ok) {
        dispatch(countryUpdated(country));

        //Investigation
        //dispatch(cleanSearchingCountrysPaginated());

        Swal.fire({
          title: t("titles.success"),
          text: t("record.update"),
          icon: 'success',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          confirmButtonText: t("buttons.close")
        }).then((result) => {
          if (result.isConfirmed) {
            setTimeout(() => {
              navigate("/admin-country");
            }, 5000);
          }
        });

      } else {
        if (body.code === "bak-error-001") {
           Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
          
        }
        if (body.code === "bak-aut-tok-inv-001") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-001"), "error");
          dispatch(startLogout());
        }
        if (body.code === "bak-aut-tok-inv-002") {
          Swal.fire(t("titles.error"), t("api.token.timed_out"), "error");
          dispatch(startLogout());
        }
      }
    } catch (error) {
      debugErrorActions(':: catalogCountryActions, countryStartUpdate', { 'error': error });
    }
  };
};

/**
 * Funcion para actualizar un evento en el store
 * @param {*} country
 * @returns
 */
const countryUpdated = (country) => {
  return {
    type: types.COUNTRY_UPDATE,
    payload: country,
  };
};

export const countryStartRegister = (country, navigate) => {
  return async (dispatch) => {
    const resp = await fetchToken(
      `${const_routes.SCHEMA}`,
      `${const_routes.VERSIONV1}`,
      `${const_routes.ROUTE_COUNTRY}`,
      "add",
      country,
      "POST"
    );

    const body = await resp.json();

     debugLogActions(':: countryActions, countryStartRegister', { 'body': body });

    if (body.ok) {
      dispatch(countryRegister(body.country));

      Swal.fire({
        title: t("titles.success"),
        text: t("record.save"),
        icon: 'success',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: t("buttons.close")
      }).then((result) => {
        if (result.isConfirmed) {
          setTimeout(() => {
            navigate("/admin-country");
          }, 5000);
        }
      });
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  };
};

const countryRegister = (country) => ({
  type: types.COUNTRY_START_REGISTER,
  payload: country,
});

export const countrySetSearchText = (searchText) => ({
  type: types.COUNTRY_SET_SEARCH_TEXT,
  payload: searchText,
});

export const countryCleanSearchText = () => ({
  type: types.COUNTRY_SET_SEARCH_TEXT,
});

/** Revision */
export const startLoadingCountrysAll = (type) => {
  return async (dispatch) => {
    const resp = await fetchToken(`${const_routes.SCHEMA}`, `${const_routes.VERSIONV1}`, `${const_routes.ROUTE_COUNTRY}`, `get`);
    const body = await resp.json();

    if (body.ok) {
      dispatch(loadingCountryAll(body.countrys));
    } else {
      if (body.code === "bak-error-001") {
         Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`  , "error");
        
      }
      if (body.code === "bak-aut-tok-inv-001") {
        Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
        dispatch(startLogout());
      }
      if (body.code === "bak-aut-tok-inv-002") {
         Swal.fire(t("titles.error"), t("alerts.validation.bak-aut-tok-inv-002"), "error");
        dispatch(startLogout());
      }
    }
  }
};

const loadingCountryAll = (countrys) => ({
  type: types.COUNTRY_START_LOADING_ALL,
  payload: countrys,
});
